import axios, { AxiosResponseHeaders } from "axios";

import apiConfig from "@/config/api";
import userService from "@/services/user";

let isLoggingOut = false;

const instance = axios.create({
  baseURL: apiConfig.apiBaseURL,
  timeout: apiConfig.timeout,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "Access-Control-Allow-Origin": "*",
    Accept: "application/vnd.argo.v2+json",
  },
});

const logout = (userInfo?: AxiosResponseHeaders) => {
  if (!isLoggingOut && userInfo) {
    userService.setLoginHistory(userInfo?.id);
    localStorage.removeItem("user");
    localStorage.removeItem("auth");

    setTimeout(() => {
      isLoggingOut = false;
      window.location.href = "/home";
    }, 0);
  }
};

instance.interceptors.request.use(
  async (config) => {
    const userAuth = localStorage.getItem("auth");
    const auth: AxiosResponseHeaders = userAuth ? JSON.parse(userAuth) : null;

    if (auth && config.headers) {
      config.headers["access-token"] = auth["access-token"];
      config.headers.client = auth.client;
      config.headers.uid = auth.uid;
      config.headers.expiry = auth.expiry;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => {
    const userAuth = localStorage.getItem("auth");
    const auth: AxiosResponseHeaders = userAuth ? JSON.parse(userAuth) : null;

    // Compare current auth with response headers
    const authKeys = ["client", "uid", "expiry", "access-token"];
    const isSame =
      auth && response.headers && authKeys.every((key) => auth[key] === response.headers[key]);

    const token = response.headers["access-token"];

    if (!isSame && token) {
      const { client, uid, expiry } = response.headers;

      if (token && client && uid && expiry) {
        // Update token locally
        localStorage.setItem(
          "auth",
          JSON.stringify({
            client,
            uid,
            expiry,
            "access-token": token,
          }),
        );
      }
    }

    return response;
  },
  (error) => {
    const userAuth = localStorage.getItem("auth");
    const auth: AxiosResponseHeaders = userAuth ? JSON.parse(userAuth) : null;

    if (error.response && error.response.status === 401) {
      isLoggingOut = true;
      logout(auth);
    }

    return Promise.reject(error);
  },
);

export default instance;
